export default __webpack_public_path__ + "static/media/训宠师勋章.f228f99f.png";